import { toast } from 'react-toastify';
import history from '../../../inits/history';
import axiosService from '../../../inits/axios';
import {
  GET_FAQS_START,
  GET_FAQS_SUCCESS,
  GET_FAQS_ERROR,
  GET_FAQ_BY_ID_START,
  GET_FAQ_BY_ID_SUCCESS,
  GET_FAQ_BY_ID_ERROR,
  CREATE_FAQ_START,
  CREATE_FAQ_SUCCESS,
  CREATE_FAQ_ERROR,
  EDIT_FAQ_START,
  EDIT_FAQ_SUCCESS,
  EDIT_FAQ_ERROR,
  DELETE_FAQ_START,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_ERROR,
} from './faq.actiontype';

import { getError } from '../../../utils/common.util';

// Get all FAQs
export const getFaqs = () => async (dispatch) => {
  try {
    dispatch({ type: GET_FAQS_START });
    const faqs = await axiosService.get('/faqs');
    dispatch({ type: GET_FAQS_SUCCESS, payload: faqs });
  } catch (error) {
    toast.error(error.message || 'Something went wrong.');
    dispatch({ type: GET_FAQS_ERROR });
  }
};

// Get single FAQ by ID
export const getFaqById = (faqId) => async (dispatch) => {
  try {
    dispatch({ type: GET_FAQ_BY_ID_START });
    const faq = await axiosService.get(`/faqs/${faqId}`);
    dispatch({ type: GET_FAQ_BY_ID_SUCCESS, payload: faq });
    return Promise.resolve(faq);
  } catch (error) {
    toast.error(error.message || 'Something went wrong.');
    dispatch({ type: GET_FAQ_BY_ID_ERROR });
    return Promise.reject(error);
  }
};

// Create new FAQ
export const createFaq = (faqInfo) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_FAQ_START });
    const faq = await axiosService.post('/faqs', faqInfo);
    toast.success('FAQ created successfully.');
    dispatch({ type: CREATE_FAQ_SUCCESS, payload: faq });
    history.push('/faqs');
  } catch (error) {
    const errorMessage = getError(error);
    toast.error(errorMessage);
    dispatch({ type: CREATE_FAQ_ERROR });
  }
};

// Edit existing FAQ
export const editFaq = (faq) => async (dispatch) => {
  try {
    dispatch({ type: EDIT_FAQ_START });
    const updatedFaq = await axiosService.put(`/faqs/${faq.id}`, faq);
    toast.success('Successfully updated.');
    dispatch({ type: EDIT_FAQ_SUCCESS, payload: updatedFaq });
    history.push('/faqs');
  } catch (error) {
    toast.error(error.message || 'Update failed.');
    dispatch({ type: EDIT_FAQ_ERROR });
  }
};

// Delete FAQ
export const deleteFaq = (faq) => async (dispatch) => {
  if (!window.confirm('Are you sure you want to delete this FAQ?')) return;

  try {
    dispatch({ type: DELETE_FAQ_START });
    const deletedFaq = await axiosService.delete(`/faqs/${faq.id}`);
    toast.success('Successfully deleted.');
    dispatch({ type: DELETE_FAQ_SUCCESS, payload: deletedFaq });
  } catch (error) {
    toast.error(error.message || 'Delete failed.');
    dispatch({ type: DELETE_FAQ_ERROR });
  }
};